<template>
  <v-card
    class="pa-4"
    flat
  >
    <h1>{{ $t('enterprises.linkCommon') }}</h1>
    <br>
    <v-container
      fill-height
      fluid
      grid-list-xl
    >
      <v-layout
        v-if="data"
        justify-center
        wrap
      >
        <v-flex
          md6
          style="text-align: center;padding-bottom:50px;border: 1px dotted gray;"
        >  
          <h3>{{ $t('commonMenus.title') }}</h3>
          <draggable class="list-group" :list="data.Free" group="people" @change="handleDraggableFree">
            <div
              class="list-group-item"
              v-for="(element, index) in data.Free"
              :key="element.name"
              :style="{ 'border-top-left-radius': index === 0 ? '5px' : '0', 'border-top-right-radius': index === 0 ? '5px' : '0', 'border-bottom-left-radius': index === data.Free.length - 1 ? '5px' : '0', 'border-bottom-right-radius': index === data.Free.length - 1 ? '5px' : '0' }"
              style="border: 1px solid #ddd;background-color: #fff; padding: 10px;cursor: pointer;"
            >
              {{ handleTranslate(element.Name) }} {{ element.Alias ? '('.concat(element.Alias, ')') : '' }}
              <!-- {{ index }} -->
            </div>
          </draggable>
        </v-flex>
        <v-flex
          md6
          style="text-align: center;padding-bottom:50px;border: 1px dotted gray;"
        >  
          <h3>{{ data.Name }}</h3>
          <draggable class="list-group" :list="data.Used" group="people" @change="handleDraggableUsed">
            <div
              class="list-group-item"
              v-for="(element, index) in data.Used"
              :key="element.name"
              :style="{ 'border-top-left-radius': index === 0 ? '5px' : '0', 'border-top-right-radius': index === 0 ? '5px' : '0', 'border-bottom-left-radius': index === data.Used.length - 1 ? '5px' : '0', 'border-bottom-right-radius': index === data.Used.length - 1 ? '5px' : '0' }"
              style="border: 1px solid #ddd;background-color: #fff; padding: 10px;cursor: pointer;"
            >
              {{ handleTranslate(element.Name) }} {{ element.Alias ? '('.concat(element.Alias, ')') : '' }}
              <!-- {{ index }} -->
            </div>
          </draggable>
          <v-snackbar
            top
            right
            v-model="snackbar"
            :timeout="timeout"
            :color="messageColor"
          >
            {{ message }}
            <v-btn
              color="black"
              text
              @click="snackbar = false"
            >
              {{ $t('common.close') }}
            </v-btn>
          </v-snackbar>
        </v-flex>
        <!-- <rawDisplayer class="col-3" :value="list1" title="List 1" />
        <rawDisplayer class="col-3" :value="list2" title="List 2" /> -->
      </v-layout>
    </v-container>
 </v-card>
</template>
<script>
import draggable from "vuedraggable"
import i18n from '@/plugins/i18n'
import utils from '@/services/utils'
import api from '@/services/api'

export default {
  name: "twolists",
  display: "Two Lists",
  order: 1,
  components: {
    draggable
  },
  data() {
    return {
      data: null,
      snackbar: false,
      message: false,
      messageColor: 'success',
      timeout: 3000,
    }
  },
  computed: {
    locale () {
      return i18n.locale
    }
  },
  mounted () {
    api.getAll(`menus/common/${this.$route.params.id}`, 1, 10000).then(response => {
      this.data = response//.filter(x => !x.ParentID)
    }).catch(function (error) {
      if (error.response.status === 403) {
        window.location.href = '/#/login'
      }
    })
  },
  methods: {
    handleTranslate (value) {
      return utils.getTranslation(value, this.locale)
    },
    handleDraggableFree (evt) {
      // console.log('free', evt)
    },
    handleDraggableUsed (evt) {
      if (evt.moved || evt.added || evt.removed) {
        const body = []
        for (let i = 0; i < this.data.Used.length; i++){
          // console.log(this.data.Used[i], i)
          body.push({
            ID: this.data.Used[i].ID,
            MCID: this.data.Used[i].MCID,
            ORD: i
          })
        }
        api.updateItem('menus/common', this.$route.params.id, body).then(response => {
          if (response.status === 200) {
            this.message = this.$t('commonMenus.messages.update')
              this.messageColor = 'success'
              this.snackbar = true
          }
        }).catch(function (error) {
          console.log('error', error)
          if (error.response.status === 403) {
            window.location.href = '/#/login'
          }
        })
      }
    }
  }
}
</script>
